"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("../../../theme/makeStyles");
var wideBorderStyles = function (color) { return ({
    '& > :last-child': {
        borderWidth: '2px',
        borderColor: color,
        outline: 'none'
    },
    '&:first-of-type > :last-child': {
        padding: ['7px', '12px', '7px', '11px']
    },
    '&:last-of-type > :last-child': {
        padding: ['7px', '11px', '7px', '12px']
    },
    '&:not(:first-of-type):not(:last-of-type) > :last-child': {
        padding: ['7px', '12px']
    }
}); };
exports.default = (0, makeStyles_1.makeStyles)(function (theme) { return ({
    focused: {
        borderColor: theme.colors.gray500
    },
    errorHelp: {
        display: 'flex',
        alignSelf: 'flex-start',
        justifyContent: 'start',
        marginTop: '4px',
        '& svg': {
            '&:first-child': {
                alignSelf: 'flex-start',
                flexShrink: '0',
                marginTop: '2px'
            }
        }
    },
    errorHelpText: {
        marginLeft: '4px'
    },
    help: {
        paddingTop: '4px'
    },
    labels: {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '4px'
    },
    textboxes: {
        display: 'flex',
        '&:focus-within': {
            '& > $fieldWrapper': wideBorderStyles(theme.colors.gray500)
        }
    },
    fieldWrapper: {
        width: '100%',
        position: 'relative'
    },
    fieldWrapperWithChildren: {
        '&:after': {
            content: "''",
            height: '16px',
            width: '2px',
            position: 'absolute',
            bottom: '16px',
            right: '0px',
            background: theme.colors.gray300
        },
        '&:first-of-type': {
            '& > :last-child': {
                borderRight: 'none',
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0
            }
        },
        '&:last-of-type': {
            '&:after': {
                content: 'none'
            },
            '& > :last-child': {
                borderLeft: 'none',
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0
            }
        },
        '&:not(:first-of-type):not(:last-of-type)': {
            '& > :last-child': {
                borderRight: 'none',
                borderLeft: 'none',
                borderRadius: 0
            }
        }
    },
    error: wideBorderStyles(theme.colors.warningAccessible),
    // Note: this is to visually hide the labels for the inputs but not for screen readers
    labelHidden: {
        border: 0,
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        width: '1px'
    },
    input: {
        width: '100%',
        color: theme.colors.gray500,
        fontFamily: theme.typography.fontFamily.serif,
        fontSize: '16px',
        lineHeight: '28px',
        textOverflow: 'ellipsis',
        border: 0,
        outline: 'none',
        '&:disabled': {
            cursor: 'not-allowed',
            '& *': {
                color: theme.colors.gray300
            },
            '& input': {
                background: 0
            }
        },
        '&::placeholder': {
            color: theme.colors.gray400
        }
    }
}); });
